import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { PPMDataEntity } from "../entites/ppm.entity";
import { PPMFileUploadEntity } from "../entites/ppm-file-upload.entity";

@Injectable()
export class PPMFileUploadRepository extends Repository<PPMFileUploadEntity> {

    constructor(private dataSource: DataSource) {
        super(PPMFileUploadEntity, dataSource.createEntityManager());

    }

    async getPPMFilesData(): Promise<any[]> {
        const query = this.createQueryBuilder('fup')
        .select(`fup.id as fileId , fup.file_name as fileName , fup.file_path as filePath,fup.buy_name as buyName, DATE_FORMAT(fup.created_at, '%Y-%m-%d %h:%i %p') AS uploadedDate ,fup.created_user as createdUser, fup.status as status`)
           .where(`fup.is_active = 1`)
            .orderBy(`fup.created_at`, 'DESC')
        return await query.getRawMany();
    }
    async getBuyersData(): Promise<any[]> {
        const query = this.createQueryBuilder('f')
            
            .select(`f.id,f.file_name AS fileName ,f.buy_name AS buyName `)
            .where(`f.is_active = 1`)
            .groupBy(`f.buy_name`)
            .orderBy(`f.created_at`, 'DESC')
        return await query.getRawMany();
    }

}